const snakeToCamel = (str) => str.toLowerCase().replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''));

const camelToSnakeCase = (str) => str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

/**
 * Plucks specified fields from an object and optionally formats the keys
 *
 * @param {Object} obj - Source object to pluck fields from
 * @param {string[]} fields - Array of field names to pluck
 * @param {string} [format] - Optional format for keys: 'camel' or 'snake'
 * @returns {Object} New object with only the specified fields
 *
 * @example
 * // Basic plucking of fields
 * pluck({id: 1, name: 'test', age: 30}, ['id', 'name'])
 * // returns {id: 1, name: 'test'}
 *
 * // Pluck and convert to camelCase
 * pluck({user_id: 1, first_name: 'John'}, ['user_id', 'first_name'], 'camel')
 * // returns {userId: 1, firstName: 'John'}
 *
 * // Pluck and convert to snake_case
 * pluck({userId: 1, firstName: 'John'}, ['userId', 'firstName'], 'snake')
 * // returns {user_id: 1, first_name: 'John'}
 */
export const pluck = (obj = {}, fields = [], format) => {
  const set = Object.entries(obj)
    .filter((n) => fields.includes(n[0]))
    .map((n) => {
      if (format === 'camel' && String(n[0]).includes('_')) {
        n[0] = snakeToCamel(n[0]);
      }
      if (format === 'snake' && !String(n[0]).includes('_')) {
        n[0] = camelToSnakeCase(n[0]);
      }
      return n;
    });
  return Object.fromEntries(set);
};
